"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconHealth = function SvgIconHealth(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "health icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Health Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27 8a4.128 4.128 0 014.122 3.967l.003.158v2.226a.75.75 0 00.668.746l.082.004h6.375a3.75 3.75 0 013.745 3.564l.005.186v18a3.75 3.75 0 01-3.564 3.745l-.186.005H9.75a3.75 3.75 0 01-3.747-3.591L6 36.85v-18a3.75 3.75 0 013.591-3.747l.159-.003h6.375a.75.75 0 00.746-.668l.004-.082v-2.226a4.128 4.128 0 013.967-4.122L21 8h6zm-1.5 13.851h-3a.75.75 0 00-.746.668l-.004.082v3a.75.75 0 01-.668.746L21 26.35h-3a.75.75 0 00-.746.668l-.004.082v3a.75.75 0 00.668.746l.082.004h3a.75.75 0 01.746.668l.004.082v3a.75.75 0 00.668.746l.082.004h3a.75.75 0 00.746-.668l.004-.082v-3a.75.75 0 01.668-.746L27 30.85h3a.75.75 0 00.746-.668l.004-.082v-3a.75.75 0 00-.668-.746L30 26.351h-3a.75.75 0 01-.746-.668l-.004-.082v-3a.75.75 0 00-.668-.746l-.082-.004zM27 11.75h-6a.38.38 0 00-.368.308l-.007.067v2.226a.75.75 0 00.668.746l.082.004h5.25a.75.75 0 00.746-.668l.004-.082v-2.226a.38.38 0 00-.308-.368L27 11.75z"
  }));
};

var _default = SvgIconHealth;
exports.default = _default;